import React from 'react'
import { deleteCookies } from '../../common/utils'
import { useNavigate } from 'react-router-dom';

const PrePost = () => {
    deleteCookies();
    const navigate = useNavigate();
    React.useEffect(()=>{
        navigate('/', { replace: true });
    },[])
  return (<></>)
}

export default PrePost;